/**
 * The web app pages whose visits are counted, as the router's route patterns.
 * A pattern, never a concrete URL: one meeting is the same page as another.
 * Sign-in, sign-out, redirect-only and one-off utility routes are left out.
 */
export const TRACKED_PAGE_ROUTES = [
  '/',
  '/meetings/$meetingId',
  '/conversations',
  '/contacts',
  '/team/',
  '/team/$colleagueId',
  '/journeys/',
  '/journeys/$journeyId',
  '/practice/',
  '/practice/new',
  '/practice/$roleplayId/',
  '/practice/$roleplayId/edit',
  '/practice/session/$sessionId',
  '/dashboard',
  '/settings/profile',
  '/settings/agenda',
  '/settings/connections',
  '/settings/meetings',
  '/settings/notifications',
  '/settings/templates',
  '/$',
  '/onboarding/welcome',
  '/onboarding/what-you-get',
  '/onboarding/how-it-works',
  '/onboarding/calendar',
  '/onboarding/colleagues',
  '/onboarding/first-meeting',
  '/onboarding/ready-to-practise',
] as const;

export type TrackedPageRoute = (typeof TRACKED_PAGE_ROUTES)[number];

export function isTrackedPageRoute(route: string): route is TrackedPageRoute {
  return TRACKED_PAGE_ROUTES.some((tracked) => tracked === route);
}

/** What the app reports when its signed-in user lands on a page. */
export interface PageVisitRequest {
  route: string;
}
